import { create } from 'zustand';

export type ToastType = 'success' | 'error';

export interface ToastOptions {
  /** Emoji shown large on the left (reco success). Makes the toast bigger. */
  icon?: string;
}

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
  icon?: string;
}

interface ToastState {
  toasts: Toast[];
  show: (type: ToastType, message: string, opts?: ToastOptions) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToast = create<ToastState>((set) => ({
  toasts: [],
  show: (type, message, opts) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, type, message, icon: opts?.icon }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 4000);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Imperative helpers for use outside React. */
export const toast = {
  success: (m: string, opts?: ToastOptions) => useToast.getState().show('success', m, opts),
  error: (m: string, opts?: ToastOptions) => useToast.getState().show('error', m, opts),
};
